import dynamic from 'next/dynamic';

const DownloadAppScreen = dynamic(() => import('./DownloadAppScreen'), { ssr: false });

export default DownloadAppScreen;
